import React from 'react';
import './MentorCard.css';

// The mentor's voice as a glass card. One component, three states:
//   'loading' -> three shimmer skeleton bars (reflection in flight)
//   'error'   -> an honest error line plus an optional Retry button
//   'content' -> a serif headline, a quiet body, and an optional action chip
// The action chip renders as a <button> when onAction is provided, otherwise as a
// non-interactive <span> (the read-only Today slot passes actionLabel with no onAction).
const MentorCard = ({ state = 'content', headline, body, actionLabel, onAction, onRetry, errorText }) => {
  if (state === 'loading') {
    return (
      <div className="mentor-card mentor-card--loading" aria-busy="true">
        <div className="mentor-skeleton-bar" />
        <div className="mentor-skeleton-bar" />
        <div className="mentor-skeleton-bar" />
      </div>
    );
  }

  if (state === 'error') {
    return (
      <div className="mentor-card mentor-card--error" role="alert">
        <p className="mentor-card-error-text">{errorText}</p>
        {onRetry && (
          <button type="button" className="mentor-card-retry" onClick={onRetry}>
            Retry
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="mentor-card">
      {headline && <h4 className="mentor-card-headline">{headline}</h4>}
      {body && <p className="mentor-card-body">{body}</p>}
      {actionLabel &&
        (onAction ? (
          <button type="button" className="mentor-card-chip" onClick={onAction}>
            {actionLabel}
          </button>
        ) : (
          <span className="mentor-card-chip mentor-card-chip--static">{actionLabel}</span>
        ))}
    </div>
  );
};

export default MentorCard;
